var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"error-container__message"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.haveList)?_c('ul',{staticClass:"error-container__list"},_vm._l((_vm.solutionList),function(solution){return _c('li',[_vm._v(_vm._s(solution))])}),0):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd056c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/error/error.html
// module id = null
// module chunks = 